<template>
  <div>
    <van-nav-bar
      title="预留改签"
      left-arrow
      @click-left="back"
      style="font-size: 12px;color: #333333;"
    />

    <div v-for="(item,index) in allData" :key="index" class="reserve_main" @click="toOrderDetail(item)" v-show="allData.length">
      <van-row class="reserve_main_title">
        <van-col span="20">
          {{ item.voyageZh }}
        </van-col>
        <van-col v-show="item.ylgqFlag==0 || !item.ylgqFlag" span="4" style="text-align:right;">
          <span>未预留</span>
        </van-col>
        <van-col v-show="item.ylgqFlag==1" style="color:#19a423;text-align:right;" span="4">
          <span>预留中</span>
        </van-col>
        <van-col v-show="item.ylgqFlag==2" style="color:#2682e9;text-align:right;" span="4">
          <span>预留完成</span>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="20">
          {{ item.departTime }} | {{ item.flightNo }} | {{ item.cabin }}
        </van-col>
        <van-col span="4" style="text-align:right;">
          ￥{{ item.saleAccount }}
        </van-col>
      </van-row>
      <van-row>
        <van-col>{{ item.psgName }}</van-col>
      </van-row>
    </div>
    <div v-if="!allData.length" class="reserve_null">
      没有更多数据了~
    </div>
  </div>
</template>
<script>
import {Cell, Field, Popup, Picker, NavBar, Button, Switch, Icon,DropdownItem} from 'vant'
import {mapGetters} from 'vuex'
import { getRelativeDate,getLongStrDate } from 'Utils/dateUtil'
export default {
  name: 'reserveRebook',
  components:{
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [NavBar.name]:NavBar,
    [Button.name]:Button,
    [Switch.name]:Switch,
    [Icon.name]:Icon,
    [DropdownItem.name]: DropdownItem,
  },
  data (){
    return {
      allData:'',
      params:{
        dateType:'1',
        drawDateStart: getRelativeDate(-90) + ' 00:00:00',
        drawDateEnd: getLongStrDate(),
      }
    }
  },
  created(){
    this.search()
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    }),
  },
  methods:{
    back(){
      this.$router.push({path:'/userCenter'})
    },
    search(){
      this.filterShow = true
      this.$api['common/ylgqList'](this.params).then(resp => {
        this.allData = resp.data.list||{}
      })
    },
    // 跳转订单详情
    toOrderDetail(item) {
      this.$router.push('/tk/tkOrderDetail?orderId=' + item.orderId)
    },
  },
}
</script>
<style lang="less" scoped>
.reserve_main{
    background-color: #fff;
    margin: 5px;
    padding: 5px 10px;
    line-height: 25px;
    .reserve_main_title{
        font-weight: 600;
    }
}
.reserve_null{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #969799;
    width: 100%;
    height: 100px;
}
</style>
